import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.sgpme.biz/api';

// Configuration axios
const restaurantAPI = axios.create({
  baseURL: `${API_URL}/restaurant`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor pour ajouter le token - CORRIGÉ
restaurantAPI.interceptors.request.use(
  (config) => {
    // CORRECTION : Utiliser 'access_token' au lieu de 'token'
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Ajouter aussi un intercepteur de réponse pour gérer les tokens expirés
restaurantAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Essayer de rafraîchir le token
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) throw new Error('No refresh token');
        
        const response = await axios.post(`${API_URL}/auth/token/refresh/`, {
          refresh: refreshToken
        });
        
        const newToken = response.data.access;
        localStorage.setItem('access_token', newToken);
        
        // Réessayer la requête originale avec le nouveau token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return restaurantAPI(originalRequest);
      } catch (refreshError) {
        // Rediriger vers la page de login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

// ===========================
// CATÉGORIES
// ===========================
export const categorieMenuAPI = {
  getAll: () => restaurantAPI.get('/categories-menu/'),
  getById: (id) => restaurantAPI.get(`/categories-menu/${id}/`),
  create: (data) => restaurantAPI.post('/categories-menu/', data),
  update: (id, data) => restaurantAPI.put(`/categories-menu/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/categories-menu/${id}/`),
};

export const categorieBoissonAPI = {
  getAll: () => restaurantAPI.get('/categories-boissons/'),
  getById: (id) => restaurantAPI.get(`/categories-boissons/${id}/`),
  create: (data) => restaurantAPI.post('/categories-boissons/', data),
  update: (id, data) => restaurantAPI.put(`/categories-boissons/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/categories-boissons/${id}/`),
};

// ===========================
// PLATS
// ===========================
// export const platAPI = {
//   getAll: (params) => restaurantAPI.get('/plats/', { params }),
//   getById: (id) => restaurantAPI.get(`/plats/${id}/`),
//   create: (data) => restaurantAPI.post('/plats/', data),
//   update: (id, data) => restaurantAPI.put(`/plats/${id}/`, data),
//   delete: (id) => restaurantAPI.delete(`/plats/${id}/`),
//   incrementSales: (id) => restaurantAPI.post(`/plats/${id}/increment-sales/`),
// };
// Dans votre fichier restaurantAPI.js
export const platAPI = {
  getAll: (params) => restaurantAPI.get('/plats/', { params }),
  getById: (id) => restaurantAPI.get(`/plats/${id}/`),
  
  // Pour la création avec FormData
  create: (formData) => {
    return restaurantAPI.post('/plats/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Pour la mise à jour avec FormData
  update: (id, formData) => {
    return restaurantAPI.put(`/plats/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Alternative: méthode PATCH pour les mises à jour partielles
  patch: (id, data) => {
    return restaurantAPI.patch(`/plats/${id}/`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  delete: (id) => restaurantAPI.delete(`/plats/${id}/`),
  incrementSales: (id) => restaurantAPI.post(`/plats/${id}/increment-sales/`),
};

// ===========================
// BOISSONS
// ===========================
export const boissonAPI = {
  getAll: (params) => restaurantAPI.get('/boissons/', { params }),
  getById: (id) => restaurantAPI.get(`/boissons/${id}/`),
  create: (data) => restaurantAPI.post('/boissons/', data),
  update: (id, data) => restaurantAPI.put(`/boissons/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/boissons/${id}/`),
  checkStock: (id) => restaurantAPI.get(`/boissons/${id}/check-stock/`),
};

// ===========================
// TABLES
// ===========================
// export const tableAPI = {
//   getAll: () => restaurantAPI.get('/tables/'),
//   getById: (id) => restaurantAPI.get(`/tables/${id}/`),
//   create: (data) => restaurantAPI.post('/tables/', data),
//   update: (id, data) => restaurantAPI.put(`/tables/${id}/`, data),
//   delete: (id) => restaurantAPI.delete(`/tables/${id}/`),
//   setStatus: (id, status) => restaurantAPI.post(`/tables/${id}/set-status/`, { status }),
//   freeTable: (id) => restaurantAPI.post(`/tables/${id}/free/`),
// };

// ===========================
// TABLES
// ===========================
export const tableAPI = {
  // Modification pour gérer la pagination Django REST Framework
  getAll: async () => {
    try {
      const response = await restaurantAPI.get('/tables/');
      console.log('Table API Raw Response:', response);
      
      // Django REST Framework retourne {count, next, previous, results}
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        return {
          ...response,
          data: response.data.results,
          pagination: {
            count: response.data.count || 0,
            next: response.data.next,
            previous: response.data.previous,
            page: 1,
            pageSize: response.data.results.length
          }
        };
      } else if (Array.isArray(response.data)) {
        // Si ce n'est pas paginé mais un tableau direct
        return {
          ...response,
          data: response.data,
          pagination: {
            count: response.data.length,
            next: null,
            previous: null,
            page: 1,
            pageSize: response.data.length
          }
        };
      } else {
        // Format inattendu
        console.warn('Format de réponse inattendu pour les tables:', response.data);
        return {
          ...response,
          data: [],
          pagination: {
            count: 0,
            next: null,
            previous: null,
            page: 1,
            pageSize: 0
          }
        };
      }
    } catch (error) {
      console.error('Erreur dans tableAPI.getAll:', error);
      throw error;
    }
  },
  
  // Ajouter une méthode pour la pagination
  getPage: async (url) => {
    try {
      const response = await restaurantAPI.get(url);
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        return {
          ...response,
          data: response.data.results,
          pagination: {
            count: response.data.count || 0,
            next: response.data.next,
            previous: response.data.previous
          }
        };
      }
      return response;
    } catch (error) {
      console.error('Erreur dans tableAPI.getPage:', error);
      throw error;
    }
  },
  
  getById: (id) => restaurantAPI.get(`/tables/${id}/`),
  create: (data) => restaurantAPI.post('/tables/', data),
  update: (id, data) => restaurantAPI.put(`/tables/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/tables/${id}/`),
  setStatus: (id, status) => restaurantAPI.post(`/tables/${id}/set-status/`, { status }),
  freeTable: (id) => restaurantAPI.post(`/tables/${id}/free/`),
  // Ajouter d'autres méthodes spécifiques si nécessaire
  marquerOccupee: (id) => restaurantAPI.post(`/tables/${id}/occuper/`),
  libererTable: (id) => restaurantAPI.post(`/tables/${id}/liberer/`),
};

// ===========================
// CHAMBRES
// ===========================
export const chambreAPI = {
  getAll: (params) => restaurantAPI.get('/chambres/', { params }),
  getById: (id) => restaurantAPI.get(`/chambres/${id}/`),
  create: (data) => restaurantAPI.post('/chambres/', data),
  update: (id, data) => restaurantAPI.put(`/chambres/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/chambres/${id}/`),
  getAvailable: (params) => restaurantAPI.get('/chambres/disponibles/', { params }),
  setStatus: (id, status) => restaurantAPI.post(`/chambres/${id}/set-status/`, { status }),
};

// ===========================
// LOCATIONS
// ===========================
export const locationAPI = {
  getAll: (params) => restaurantAPI.get('/locations/', { params }),
  getById: (id) => restaurantAPI.get(`/locations/${id}/`),
  create: (data) => restaurantAPI.post('/locations/check-in/', data),
  checkOut: (id, data) => restaurantAPI.post(`/locations/${id}/check-out/`, data),
  update: (id, data) => restaurantAPI.put(`/locations/${id}/`, data),
  getActive: () => restaurantAPI.get('/locations/actives/'),
  addService: (id, data) => restaurantAPI.post(`/locations/${id}/add-service/`, data),
};

// ===========================
// COMMANDES
// ===========================
export const commandeAPI = {
  getAll: (params) => restaurantAPI.get('/commandes/', { params }),
  getById: (id) => restaurantAPI.get(`/commandes/${id}/`),
  create: (data) => restaurantAPI.post('/commandes/', data),
  update: (id, data) => restaurantAPI.put(`/commandes/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/commandes/${id}/`),
  demanderAddition: (id) => restaurantAPI.post(`/commandes/${id}/demander-addition/`),
  payer: (id, data) => restaurantAPI.post(`/commandes/${id}/payer/`, data),
  addItems: (id, data) => restaurantAPI.post(`/commandes/${id}/add-items/`, data),
  getByTable: (tableId) => restaurantAPI.get(`/commandes/table/${tableId}/`),
  getActive: () => restaurantAPI.get('/commandes/actives/'),
};

// ===========================
// EMPLOYÉS
// ===========================
export const employeAPI = {
  getAll: () => restaurantAPI.get('/employes/'),
  getById: (id) => restaurantAPI.get(`/employes/${id}/`),
  create: (data) => restaurantAPI.post('/employes/', data),
  update: (id, data) => restaurantAPI.put(`/employes/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/employes/${id}/`),
  endContract: (id, date) => restaurantAPI.post(`/employes/${id}/end-contract/`, { date_depart: date }),
};

// ===========================
// DÉPENSES
// ===========================
export const depenseAPI = {
  getAll: (params) => restaurantAPI.get('/depenses/', { params }),
  getById: (id) => restaurantAPI.get(`/depenses/${id}/`),
  create: (data) => restaurantAPI.post('/depenses/', data),
  update: (id, data) => restaurantAPI.put(`/depenses/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/depenses/${id}/`),
  getStats: (params) => restaurantAPI.get('/depenses/stats/', { params }),
};

// ===========================
// MENU & DASHBOARD
// ===========================
export const menuAPI = {
  getMenuComplet: () => restaurantAPI.get('/menu-complet/'),
  getCategoriesWithItems: () => restaurantAPI.get('/menu/categories/'),
  getStats: () => restaurantAPI.get('/dashboard/stats/'),
  getTopSelling: (limit = 5) => restaurantAPI.get(`/menu/top-selling/?limit=${limit}`),
};

// ===========================
// OPTIONS DE PLATS
// ===========================
export const optionPlatAPI = {
  getAll: () => restaurantAPI.get('/option-plats/'),
  getById: (id) => restaurantAPI.get(`/option-plats/${id}/`),
  create: (data) => restaurantAPI.post('/option-plats/', data),
  update: (id, data) => restaurantAPI.put(`/option-plats/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/option-plats/${id}/`),
  getByPlat: (platId) => restaurantAPI.get(`/option-plats/plat/${platId}/`),
};

// ===========================
// RÉSERVATIONS
// ===========================
export const reservationAPI = {
  getAll: (params) => restaurantAPI.get('/reservations/', { params }),
  getById: (id) => restaurantAPI.get(`/reservations/${id}/`),
  create: (data) => restaurantAPI.post('/reservations/', data),
  update: (id, data) => restaurantAPI.put(`/reservations/${id}/`, data),
  delete: (id) => restaurantAPI.delete(`/reservations/${id}/`),
  confirm: (id) => restaurantAPI.post(`/reservations/${id}/confirm/`),
  cancel: (id) => restaurantAPI.post(`/reservations/${id}/cancel/`),
  checkIn: (id) => restaurantAPI.post(`/reservations/${id}/check-in/`),
};
export default restaurantAPI;